import { Component, OnInit, Injector } from '@angular/core';
import {
    TenantDashboardServiceProxy,
    ProcessorEngineLogServiceProxy,
    IProcessorEngineLogCountQueryInput,
    ProcessorEngineLogCountQueryInput,
    ProcessorEngineLogQueryInput,
    ProcessorEngineLogDto
} from '@shared/service-proxies/service-proxies';
import { DashboardChartBase } from '../dashboard-chart-base';
import { WidgetComponentBase } from '../widget-component-base';

class DailySalesLineChart extends DashboardChartBase {
    showYAxisLabel: boolean = true;
    showXAxisLabel: boolean = true;

  chartData: any[];
  scheme: any = {
    name: 'green',
    selectable: true,
      group: 'Ordinal',
    
    domain: [
      '#dc3545'
    ]
  };

  constructor(private _engineLogService: ProcessorEngineLogServiceProxy) {
    super();
  }

  init(data) {
    this.chartData = [];
    for (let i = 0; i < data.length; i++) {
      this.chartData.push({
          name: data[i].time,
          value: data[i].errors
      });
    }
  }


  getApiCallData() {

      //{
      //    "fieldName": "level.keyword",
      //        "timeStampFieldName": "@timestamp",
      //        "selector": "ErrorApiCallFeed"
      //}

      const input: IProcessorEngineLogCountQueryInput = {
          selector: "ErrorApiCallFeed",
          fieldName: "level.keyword",
          timeStampFieldName: "@timestamp",
          query: undefined,
          logDashboardId: undefined
      };

      this._engineLogService.queryCountLogs(new ProcessorEngineLogCountQueryInput(input))
          .subscribe((result: any) => {
              console.log(result);
              this.init(result);
              this.hideLoading();
          });


  }


  reload() {
      this.showLoading();

      this.getApiCallData();
  }
}

@Component({
  selector: 'app-widget-error-apicall-daily',
    templateUrl: './widget-error-apicall-daily.component.html',
    styleUrls: ['./widget-error-apicall-daily.component.css']
})
export class WidgetErrorApiCallDailyComponent extends WidgetComponentBase implements OnInit {

  dailySalesLineChart: DailySalesLineChart;

  constructor(injector: Injector,
      private _engineLogService: ProcessorEngineLogServiceProxy) {
      super(injector);

      this.dailySalesLineChart = new DailySalesLineChart(this._engineLogService);
  }


  ngOnInit() {
    this.dailySalesLineChart.reload();
  }
}
